import { supabase } from './supabase';

export type ExpenseApprovalStatus = 'pending' | 'approved';

export type ExpenseWithReceipts = {
  approval_status?: ExpenseApprovalStatus | string | null;
  ai_categorized?: boolean;
  receipts?: Array<{ processing_status?: string | null }> | null;
};

export function expenseReceiptIsProcessing(expense: ExpenseWithReceipts): boolean {
  const status = expense.receipts?.[0]?.processing_status;
  return status === 'processing' || status === 'pending';
}

/** The receipt file was saved, but the AI call did not finish. */
export function expenseReceiptFailed(expense: ExpenseWithReceipts): boolean {
  return expense.receipts?.[0]?.processing_status === 'failed';
}

/** Still waiting for a person to double-check an AI categorization. The expense already counts. */
export function expenseNeedsApproval(expense: ExpenseWithReceipts): boolean {
  return expense.approval_status === 'pending';
}

/** AI finished and a person has marked the categorization as reviewed. */
export function expenseIsCategorized(expense: ExpenseWithReceipts): boolean {
  return !expenseNeedsApproval(expense) && !expenseReceiptIsProcessing(expense);
}

export async function approveExpense(expenseId: string): Promise<void> {
  const { data: { user } } = await supabase.auth.getUser();
  const now = new Date().toISOString();

  const { error } = await supabase
    .from('expenses')
    .update({
      approval_status: 'approved',
      approved_at: now,
      approved_by: user?.id ?? null,
      updated_at: now,
    })
    .eq('id', expenseId);

  if (error) throw error;

  window.dispatchEvent(new CustomEvent('expensesUpdated'));
}
